// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-colorful {
  width: 268px;
}
.react-colorful__saturation {
  box-shadow: none;
  border: 1px solid;
  border-color: var(--black2);
  border-radius: 0.5rem;
}
.react-colorful__hue {
  margin: 8px 0px;
  border: 1px solid;
  border-color: var(--black2);
  border-radius: 0.5rem;
}

.builder-autocomplete .MuiOutlinedInput-root {
  padding: 0px;
}
.builder-autocomplete .MuiOutlinedInput-root .MuiOutlinedInput-input {
  padding: 7px 10px;
}
.builder-autocomplete .MuiIconButton-root {
  border-radius: 0.5rem;
  color: var(--black6);
}
.builder-autocomplete .MuiIconButton-root.MuiTouchRipple-root {
  display: none;
}

.builder-text-field {
  background: white !important;
  border: 1px solid var(--black2) !important;
  border-radius: 0.5rem !important;
}
.builder-text-field .MuiOutlinedInput-input,
.builder-text-field .MuiAutocomplete-input {
  padding: 7px 10px !important;
  color: black !important;
}
.builder-text-field .MuiOutlinedInput-notchedOutline {
  display: none;
}

.popper-paylixecommerce .MuiPaper-root {
  background: var(--black9);
  margin-top: 7px;
  border: 1px solid;
  border-color: var(--black2);
  box-shadow: none;
}
.popper-paylixecommerce .MuiPaper-root .MuiAutocomplete-listbox {
  padding: 4px 0;
}
.popper-paylixecommerce .MuiPaper-root .MuiAutocomplete-listbox .MuiAutocomplete-option {
  color: var(--black9);
}
.popper-paylixecommerce .MuiPaper-root .MuiAutocomplete-listbox .MuiAutocomplete-option.Mui-focused {
  background: var(--black9);
}
.popper-paylixecommerce .MuiPaper-root .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected=true] {
  background: #181818;
  color: var(--black9);
}

.PickColorPopper-wrapper {
  padding: 0.5rem;
  margin-left: -52px;
  box-shadow: none;
  border: 1px solid;
  border-color: var(--black2);
  background: var(--black9);
  border-radius: 0.5rem;
}
.PickColorPopper-wrapper #current-color {
  display: none;
}

.color-picker-input {
  margin-top: 0.5rem;
}

.color-picker-select {
  margin-top: 0.5rem;
  color: var(--black5);
  font-size: 13px;
}
.color-picker-select #color-button {
  width: 24px;
  height: 24px;
  border: 1px solid;
  border-color: var(--black2);
  border-radius: 0.5rem;
  cursor: pointer;
  margin: 4px 4px 0 0;
}
.color-picker-select #color-button:hover {
  border-color: var(--purple6);
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/builder/screens/visual/EditorMenu/components/color-picker.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;AACJ;AAEE;EACE,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;AAAJ;;AAKE;EACE,YAAA;AAFJ;AAII;EACE,iBAAA;AAFN;AAME;EACE,qBAAA;EACA,oBAAA;AAJJ;AAMI;EACE,aAAA;AAJN;;AASA;EACE,4BAAA;EACA,0CAAA;EACA,gCAAA;AANF;AAQE;;EAEE,4BAAA;EACA,uBAAA;AANJ;AASE;EACE,aAAA;AAPJ;;AAYE;EACI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;EACA,gBAAA;AATN;AAWI;EACE,cAAA;AATN;AAWM;EACE,oBAAA;AATR;AAWQ;EACE,yBAAA;AATV;AAaM;EACE,mBAAA;EACA,oBAAA;AAXR;;AAkBE;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,yBAAA;EACA,qBAAA;AAfJ;AAiBI;EACE,aAAA;AAfN;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;AAvBF;AAyBE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,2BAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;AAvBJ;AAyBI;EACE,4BAAA;AAvBN","sourcesContent":[".react-colorful {\n  width: 268px;\n\n  &__saturation {\n    box-shadow: none;\n    border: 1px solid;\n    border-color: var(--black2);\n    border-radius: .5rem;\n  }\n  \n  &__hue {\n    margin: 8px 0px;\n    border: 1px solid;\n    border-color: var(--black2);\n    border-radius: .5rem;\n  }\n}\n\n.builder-autocomplete {\n  .MuiOutlinedInput-root {\n    padding: 0px;\n\n    .MuiOutlinedInput-input {\n      padding: 7px 10px;\n    };\n  };\n  \n  .MuiIconButton-root {\n    border-radius: .5rem;\n    color: var(--black6);\n\n    &.MuiTouchRipple-root {\n      display: none;\n    }\n  }\n}\n\n.builder-text-field {\n  background: white !important;\n  border: 1px solid var(--black2) !important;\n  border-radius: 0.5rem !important;\n\n  .MuiOutlinedInput-input,\n  .MuiAutocomplete-input {\n    padding: 7px 10px !important;\n    color: black !important;\n  };\n\n  .MuiOutlinedInput-notchedOutline {\n    display: none;\n  };\n}\n\n.popper-paylixecommerce {\n  .MuiPaper-root {\n      background: var(--black9);\n      margin-top: 7px;\n      border: 1px solid;\n      border-color: var(--black2);\n      box-shadow: none;\n    \n    .MuiAutocomplete-listbox {\n      padding: 4px 0;\n    \n      .MuiAutocomplete-option {\n        color: var(--black9);\n      \n        &.Mui-focused {\n          background: var(--black9);\n        };\n      };\n      \n      .MuiAutocomplete-option[aria-selected=\"true\"] {\n        background: #181818;\n        color: var(--black9);\n      }\n    }\n  }\n}\n\n.PickColorPopper {\n  &-wrapper {\n    padding: .5rem;\n    margin-left: -52px;\n    box-shadow: none;\n    border: 1px solid;\n    border-color: var(--black2);\n    background: var(--black9);\n    border-radius: .5rem;\n    \n    #current-color {\n      display: none;\n      //width: 24px;\n      //height: 24px;\n      //border: 1px solid;\n      //border-color: var(--black2);\n      //border-radius: .5rem;\n      //margin-right: 8px;\n    }\n  }\n}\n\n.color-picker-input {\n  margin-top: .5rem;\n}\n\n.color-picker-select {\n  margin-top: .5rem;\n  color: var(--black5);\n  font-size: 13px;\n  \n  #color-button {\n    width: 24px;\n    height: 24px;\n    border: 1px solid;\n    border-color: var(--black2);\n    border-radius: .5rem;\n    cursor: pointer;\n    margin: 4px 4px 0 0;\n  \n    &:hover {\n      border-color: var(--purple6);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
